import { render, staticRenderFns } from "./PresetActionDelete.vue?vue&type=template&id=7ca7dd70&"
import script from "./PresetActionDelete.vue?vue&type=script&lang=ts&"
export * from "./PresetActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports